













































































































import {
	defineComponent,
	ref,
	Ref,
	watch,
} from '@vue/composition-api';
import { UsersLearningProgram } from '@front-app/modules/learningPrograms/Model';
import { CurrentUserStore } from '@front-app/store/singletons/User';
import { lmsUserApi } from '@front-app/modules/learningPrograms/api/lms-api';
import { getLearningProgramsStore } from '@front-app/modules/learningPrograms/store/LearningProgramsStore';
import { useAsyncStatus } from '@front-app/hooks/useAsyncStatus';
import SimpleCard from '@front-app/components/cards/SimpleCard.vue';
import ErrorCard from '@front-app/components/cards/state/ErrorCard.vue';
import ColumnContainer from '@front-app/components/layouts/columns/ColumnContainer.vue';
import PaddedContent from '@front-app/components/layouts/columns/PaddedContent.vue';
import ScrollingColumn from '@front-app/components/layouts/columns/ScrollingColumn.vue';
import LoaderState from '@front-app/components/LoaderState.vue';
import { GroupsStore } from '@front-app/store/singletons/Groups';
import ColumnHeader from '@front-app/components/layouts/columns/ColumnHeader.vue';
import LearningMeta from '@front-app/modules/learningPrograms/components/LearningMeta.vue';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import { Routes } from '@front-app/constants/routes';
import { Size } from '@front-app/components/constants';
import CompletedBadge from '@front-app/modules/learningPrograms/components/CompletedBadge.vue';
import { isProgramPublished } from '@front-app/modules/learningPrograms/util/util';

export default defineComponent({
	components: {
		ColumnContainer,
		ScrollingColumn,
		PaddedContent,
		SimpleCard,
		ErrorCard,
		LoaderState,
		ColumnHeader,
		LearningMeta,
		CtaButton,
		CompletedBadge,
	},
	setup() {
		const programsStore = getLearningProgramsStore();
		const groupsStore = GroupsStore.getInstance();
		const userPrograms: Ref<UsersLearningProgram[]> = ref([]);
		const {
			track,
			isError: isErrorFetchingPrograms,
			isLoading: isLoadingPrograms,
		} = useAsyncStatus();
		watch(() => CurrentUserStore.currentUser.value.id, async () => {
			const { data } = await track(lmsUserApi.listStartedProgramsForUser());
			data.forEach(({ groupId, program }) => {
				programsStore.setProgram(program.id, { ...program, modules: [] });
				groupsStore.fetchGroup(groupId);
			});
			userPrograms.value = data.map((_) => ({ ..._, program: programsStore.getProgram(_.program.id) }));
		}, { immediate: true });

		const toProgram = (groupId: string, programId: string) => ({ name: Routes.GROUP_LEARNING_PROGRAM, params: { groupId, programId } });
		const toGroup = (groupId: string) => ({ name: Routes.GROUP, params: { groupId } });
		const getGroupName = (groupId: string) => groupsStore.groupById(groupId)?.name;
		const isGroupLoading = (groupId: string) => groupsStore.isGroupLoading(groupId);

		return {
			// Basic Page Loading State
			isErrorFetchingPrograms,
			isLoadingPrograms,
			// Programs
			userPrograms,
			isProgramPublished,
			toProgram,
			// Groups
			getGroupName,
			toGroup,
			isGroupLoading,
			// Util
			ButtonPalettes,
			Size,
		};
	},
});
